module.exports = __webpack_public_path__ + "img/b9_02.626afe3b.jpg";